import React from 'react';
import Button from './Button';
import { ButtonProps } from './Button';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type IconButtonProps = Omit<ButtonProps, 'startIcon' | 'endIcon'> & {
  icon: IconDefinition;
  iconProps?: Omit<React.ComponentProps<typeof FontAwesomeIcon>, 'icon'>;
};

const IconButton: React.FC<IconButtonProps> = ({ icon, iconProps, ...rest }) => {
  return (
    <Button {...rest}>
      <FontAwesomeIcon size="lg" icon={icon} {...iconProps} />
    </Button>
  );
};

export default IconButton;
